import { STANDARD_SYMBOL_MAPPING } from "@buildwithflux/constants";
import { getPartType } from "@buildwithflux/models";
/**
 * Gets the standard symbol path for a part version based on its part_type property.
 * This is used to set the preview_image when publishing a part.
 *
 * @param partVersion - The part version data to get the standard symbol for
 * @returns The standard symbol path or undefined if no standard symbol exists
 */
export function getStandardSymbolForPartVersion(partVersion) {
    const partType = getPartType(partVersion);
    if (!partType) {
        return undefined;
    }
    return STANDARD_SYMBOL_MAPPING[partType];
}
/**
 * Enhances a part version with a preview image if needed.
 * This should be called after createPartVersionFromDocument to set the preview_image.
 *
 * The preview image fallback logic is:
 * 1. If a custom preview_image is already set, keep it
 * 2. If the part has a recognized standard symbol type (resistor, capacitor, etc.), use that symbol
 * 3. Otherwise, leave preview_image undefined - the frontend will show the default ModuleIcon
 *    for published parts via DocumentStorageHelper.getPreviewUrl() fallback logic
 *
 * @param partVersion - The part version data to enhance
 * @returns Enhanced part version data with preview_image set (if a standard symbol exists)
 */
export function enhancePartVersionWithStandardSymbolPreview(partVersion) {
    // If preview_image is already set, don't override it
    if (partVersion.preview_image) {
        return partVersion;
    }
    // Try to get a standard symbol for the part type
    const standardSymbolPath = getStandardSymbolForPartVersion(partVersion);
    if (standardSymbolPath) {
        return {
            ...partVersion,
            preview_image: standardSymbolPath,
        };
    }
    // For parts without a standard symbol, leave preview_image undefined.
    // The frontend's DocumentStorageHelper.getPreviewUrl() will return ModuleIcon
    // as a fallback for published parts without a preview_image.
    return partVersion;
}
//# sourceMappingURL=parametricPreview.js.map